import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './components/App';
import store from './store';
import {Provider} from 'react-redux';
import i18n from './i18n';
import ClientTheme from './components/theme/ClientTheme';

import CustomHeadImport from "./components/CustomHead/CustomHeadImport";
import OneTrustContainer from "./components/CustomHead/OneTrustContainer";

ReactDOM.render(
    <Provider store={store}>
        <React.StrictMode>
            <React.Suspense fallback="Loading...">
                <OneTrustContainer/>
                <CustomHeadImport/>
                <ClientTheme>
                    <i18n/>
                    <App/>
                </ClientTheme>
            </React.Suspense>
        </React.StrictMode>
    </Provider>,
    document.getElementById('root')
);
